import { Alert } from 'types/alert'
import * as constants from 'actions/constants'

export interface AlertReducer {
  alert: any | Alert
}

const defaultState: AlertReducer = {
  alert: null,
}

let alert: Alert | any = null //TEMPORARY VARIABLE TO BE USED TO EDIT ALERT BEFORE UPDATING THE STATE

const getSeverity = (success: boolean) => {
  return success ? 'success' : 'error'
}

export default function alertReducer(state = defaultState, action: any) {
  switch (action.type) {
    case constants.REMOVE_ALERT:
      return Object.assign({}, state, { alert: null })
    case constants.ADD_ALERT:
      return Object.assign({}, state, { alert: action.alert })
    case constants.RESET_PASSWORD_RESPONSE:
      return Object.assign({}, state, {
        alert: {
          severity: "success",
          message: "Password was reset. Please check your email!",
        },
      })

    case constants.RESET_PASSWORD_ERROR:
      return Object.assign({}, state, {
        alert: {
          severity: "error",
          message: "Couldnt reset the password!",
        },
      })
    case constants.TEST_ALERT:
      return Object.assign({}, state, { alert: action.alert })

    case constants.UPDATE_MY_PROFILE_RESPONSE:
      return Object.assign({}, state, {
        alert: {
          severity: getSeverity(action.response.success),
          message: action.response.message,
        },
      })

    case constants.DELETE_MY_PROFILE_RESPONSE:
      return Object.assign({}, state, {
        alert: {
          severity: getSeverity(action.response.success),
          message: action.response.message,
        },
      })

    case constants.DELETE_MY_PROFILE_ERROR:
      return Object.assign({}, state, {
        alert: {
          severity: "error",
          message: "Couldnt delete account!",
        },
      })
    case constants.CREATE_EVENT_RESPONSE:
      return Object.assign({}, state, {
        alert: {
          severity: getSeverity(action.response.success),
          message: action.response.message,
        },
      })

    case constants.LOGIN_RESPONSE:
      return Object.assign({}, state, {
        alert: action.alert || {
          severity: getSeverity(!!action.user),
          message: !!action.user
            ? 'Logged in successfully'
            : 'Failed to Log in',
        },
      })

    case constants.LOGIN_ERROR:
      return Object.assign({}, state, {
        alert: action.alert || {
          severity: 'error',
          message: 'Failed to Log in',
        },
      })

    case constants.SIGNUP_RESPONSE:
      return Object.assign({}, state, {
        alert: action.alert || {
          severity: getSeverity(!!action.user),
          message: !!action.user
            ? 'Account was created successfully'
            : 'Failed to Sign up',
        },
      })
    case constants.SIGNUP_ERROR:
      if (action.error && action.error.code === 'auth/email-already-in-use')
        return Object.assign({}, state, {
          alert: {
            severity: getSeverity(false),
            message: 'There is another account with the same email',
          },
        })

      return Object.assign({}, state, {
        alert: {
          severity: getSeverity(false),
          message: 'There has been an error with signing up. Please try again later!',
        },
      })

    default:
      if (action?.response?.code === 'FORCE_LOGOUT_FRONTEND'){
        //KEEP THE ALERTS EVEN WHEN LOGGING OUT
        // return defaultState
      }
      return state
  }
}
